import { Convoy } from '@rtls/core/models/convoy/convoy.model';
import { participantFactory } from '@rtls/core/models/convoy/participant.factory';
import { tripFactory } from '@rtls/core/models/convoy/trip.factory';
import { random, randomDate, randomName, randomNumber, randomSizeList } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const convoyFactory = Factory.makeFactory<Convoy>({
	id: Factory.each((i) => i),
	createdDate: Factory.each(() => randomDate()),
	startDate: Factory.each(() => randomDate()),
	name: Factory.each(() => randomName()),
	length: Factory.each(() => randomNumber() * 1000),
	completed: Factory.each(() => random()),
	trip: Factory.each(() => tripFactory.build()),
	participants: Factory.each(() =>
		randomSizeList(
			() => participantFactory.build(),
			30,
			() => random(30),
		),
	),
});
